import '../io/lab/index.js';
import Color from '../Color.js';
import mix from '../generator/mix.js';
Color.prototype.tint = function () {
  var f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }
  return mix.apply(void 0, [this, 'white', f].concat(rest));
};
Color.prototype.shade = function () {
  var f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
  for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    rest[_key2 - 1] = arguments[_key2];
  }
  return mix.apply(void 0, [this, 'black', f].concat(rest));
};